import React, { useRef, useState } from 'react';
import { ZoomIn } from 'lucide-react';

/**
 * Zoom-on-hover image viewer.
 * Desktop : large preview that zooms 2× on the hovered area.
 * Mobile : tap to enter a fullscreen lightbox.
 */
export const ImageZoom = ({ src, alt = '', zoom = 2 }) => {
  const ref = useRef(null);
  const [hover, setHover] = useState(false);
  const [pos, setPos] = useState({ x: 50, y: 50 });
  const [lightbox, setLightbox] = useState(false);

  const onMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setPos({ x: Math.max(0, Math.min(100, x)), y: Math.max(0, Math.min(100, y)) });
  };

  return (
    <>
      <div
        ref={ref}
        className="relative aspect-square rounded-2xl overflow-hidden bg-slate-50 cursor-zoom-in group"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onMouseMove={onMove}
        onClick={() => setLightbox(true)}
        data-testid="image-zoom"
      >
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover transition-transform duration-300"
          style={
            hover
              ? {
                  transform: `scale(${zoom})`,
                  transformOrigin: `${pos.x}% ${pos.y}%`,
                }
              : undefined
          }
          loading="eager"
        />
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          <ZoomIn className="w-4 h-4 text-[#0F4C5C]" />
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 bg-black/85 backdrop-blur-sm z-[80] flex items-center justify-center p-4 cursor-zoom-out"
          onClick={() => setLightbox(false)}
          data-testid="image-lightbox"
        >
          <img src={src} alt={alt} className="max-w-full max-h-full object-contain" />
        </div>
      )}
    </>
  );
};
